import { useLayoutEffect, useRef } from "react";

/**
 * One line of text that shrinks to fit its box: never wraps, never trails off in dots.
 * For names on the wall, where a nickname can be any length. Shrinks to `min` of its CSS size.
 */
export function FitText({ children, className, min = 0.45 }: { children: string; className?: string; min?: number }) {
  const outer = useRef<HTMLSpanElement>(null);
  const inner = useRef<HTMLSpanElement>(null);
  useLayoutEffect(() => {
    const o = outer.current;
    const i = inner.current;
    if (!o || !i) return;
    const fit = () => {
      i.style.transform = "";
      const room = o.clientWidth;
      const need = i.scrollWidth;
      const k = need > room && need > 0 ? Math.max(min, room / need) : 1;
      i.style.transform = k < 1 ? `scale(${k})` : "";
    };
    fit();
    const ro = new ResizeObserver(fit);
    ro.observe(o);
    void document.fonts?.ready.then(fit);
    return () => ro.disconnect();
  }, [children, min]);
  return (
    <span ref={outer} className={className} style={{ display: "block", minWidth: 0, overflow: "hidden", whiteSpace: "nowrap" }}>
      <span ref={inner} style={{ display: "inline-block", transformOrigin: "left center" }}>
        {children}
      </span>
    </span>
  );
}
